import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import type { ClientResponse } from '../classes/ClientResponse';

export interface ChangeMyPasswordRequest {
  currentPassword: string;
  newPassword: string;
}

export interface ChangeMyPasswordResponse {
  token: string;
  message: string;
}

export interface AdminResetPasswordRequest {
  userId: number;
  newPassword: string;
}

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  private http = inject(HttpClient);

  private readonly endpoint = environment.apiUrl;
  private readonly userEndpoint = `${this.endpoint}/user`;

  changeMyPassword(
    request: ChangeMyPasswordRequest,
  ): Observable<ClientResponse<ChangeMyPasswordResponse>> {
    return this.http.put<ClientResponse<ChangeMyPasswordResponse>>(
      `${this.userEndpoint}/me/password`,
      request,
    );
  }

  adminResetPassword(request: AdminResetPasswordRequest): Observable<ClientResponse> {
    return this.http.put<ClientResponse>(`${this.userEndpoint}/admin/reset-password`, request);
  }

  generateTempPassword(): Observable<ClientResponse> {
    return this.http.get<ClientResponse>(`${this.userEndpoint}/admin/generate-password`);
  }
}
